import classNames from 'classnames';
import { useTranslate } from '@tolgee/react';

export default function AlertBanner(props: { className?: string; description: string }) {
  const { t } = useTranslate();

  return (
    <div className={classNames('alert-banner', props.className)}>
      <p className="alert-banner__content">
        <a href="#">
          <strong className="alert-banner__title">{t('online-order.alert.title', 'Alert')}</strong>
          <svg viewBox="0 0 2 2" className="alert-banner__separator" aria-hidden="true">
            <circle cx={1} cy={1} r={1} />
          </svg>
          <span className="alert-banner__message">{props.description}</span>
        </a>
      </p>
      <div className="alert-banner__spacer"></div>
    </div>
  );
}
